<template>
  <div class="promo columns">
    <div class="column">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="handleDeletePromo"/>
      <b-switch v-model='promoObject.isHidden' @change="handleUpdatePromo">Скрыть акцию с сайта</b-switch>
      <span class="picker-label">Время проведения акции</span>
      <el-date-picker
        v-model="date"
        :editable="false"
        type="datetimerange"
        @change="dateChanged"
        placeholder="Время проведения акции">
      </el-date-picker>
      <div class="is-flex">
        <b-switch v-model='promoObject.publishLater'>Опубликовать позже</b-switch>
        <el-date-picker class="publish-date-picker"
          v-model="publishDate"
          type="datetime"
          :editable="false"
          @change="dateChanged"
          placeholder="Дата и время публикации">
        </el-date-picker>
      </div>
      <b-field>
        <b-input placeholder="Название акции"
        @change="handleUpdatePromo"
        type="textarea" class="title"
        required v-model="promoObject.title"></b-input>
      </b-field>
      <b-field>
        <b-input
        placeholder="Условия акции"
        @change="handleUpdatePromo"
        type="textarea" required v-model="promoObject.conditions"></b-input>
      </b-field>

      <b-field label="Параметры кнопки" class="promo-button-wrapper">
        <b-input
          placeholder="Ссылка на страницу, если нужна"
          @change="handleUpdatePromo"
          v-model="promoObject.url">
        </b-input>
        <b-input
          placeholder="Название кнопки"
          @change="handleUpdatePromo"
          v-model="promoObject.urlButton">
        </b-input>
      </b-field>
      <b-field>
      </b-field>
      <div class="save-content-button centered">
        <button class="button save-content" @click="handleSavePromo()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
    </div>
    <!-- <div class="column is-one-third">
      <div class="is-flex photo-wrapper" v-bind:style="rightColumnStyle">
        <img src="/static/img/icons/trash.svg" class="trash-icon" @click="handleDeletePromoPhoto" v-if="promo.photo"/>
        <span class="button-wrapper" v-else
        @click="handleLoadPromoPhoto"><a class="button is-info">+</a>Загрузить фото</span>
        <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
      </div>
    </div> -->
</div>
</template>

<script>
  import { mapActions } from 'vuex'
  import deepcopy from 'deepcopy'

  export default {
    name: 'Promo',
    data () {
      return {
        updateTimer: 0,
        defaultDate: [this.promo.startDate, this.promo.endDate],
        publishDate: null,
        date: null,
        disabled: false
      }
    },
    computed: {
      promoObject () {
        return deepcopy(this.promo)
      },
      rightColumnStyle () {
        return this.promo && this.promo.photo
        ? {background: `url(/upload/photos/${this.promo.photo})`}
        : {background: ''}
      }
    },
    props: {
      promo: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deletePromo', 'loadPromoPhoto', 'deletePromoPhoto', 'savePromo', 'updatePromo']),
      handleDeletePromo () {
        this.deletePromo(this.promo.id)
      },
      handleLoadPromoPhoto () {
        this.$refs.loadPhotoButton.click()
      },
      handleDeletePromoPhoto () {
        this.deletePromoPhoto(this.promo.id)
      },
      handleSavePromo () {
        this.disabled = true
        this.savePromo(this.promoObject)
        .then(() => {
          this.disabled = false
          this.$toast.open({ message: 'Сохранено' })
        })
      },
      loadPhoto (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        this.loadPromoPhoto({ formData, id: this.promoObject.id })
      },
      dateChanged (dates) {
        this.promoObject.startDate = this.date[0]
        this.promoObject.endDate = this.date[1]
        this.promoObject.publishDate = this.publishDate
        this.handleUpdatePromo()
      },
      handleUpdatePromo () {
        this.updatePromo(this.promoObject)
      }
    },
    created () {
      this.date = [this.promoObject.startDate, this.promoObject.endDate]
      this.publishDate = this.promoObject.publishDate || null
    }
  }
</script>

<style scoped>
.save-content {
  margin-bottom: 0;
}
.promo {
  background: #eeeeee;
  padding: 30px;
  margin: 20px auto;
  max-width: 800px;
  position: relative;
}
.el-date-editor {
  width: 100%;
}
.el-picker-panel {
  max-width: 700px;
}
.switch {
  margin: 15px 0;
  display: inline-block;
  width: 340px;
}
.delete-icon {
  top: -10px;
  right: -10px;
  width: 30px;
}
.picker-label {
  color: #7a7a7a;
  display: block;
  margin: 5px 0;
}
.el-date-editor--datetimerange {
  margin: 0 0 15px;
}
.photo-wrapper {
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
}
.promo-button-wrapper {
  flex-direction: column;
}
.promo-button-wrapper .control {
  margin: 0 0 15px;
}
.publish-date-picker {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// Promo.vue?10252092